export default {
	NONE: 0,
	INFORMATION: 1,
	QUESTION: 2,
	0: 'NONE',
	1: 'INFORMATION',
	2: 'QUESTION'
};
